// extracted by mini-css-extract-plugin
module.exports = {"btn":"qr-reader_btn__3c-rp","closeModal":"qr-reader_closeModal__3F7id","modal":"qr-reader_modal__3193Q","container":"qr-reader_container__3up9n","result":"qr-reader_result__1J-TR"};